<div class="welcome-page-view__container">
  <empathy-viewer-template-card [noHeader]="true">
    @if (surveyModel().welcomeStimulus?.length > 0) {
      <empathy-stimulus slot="stimulus" [expandable]="false" [stimulus]="surveyModel().welcomeStimulus"></empathy-stimulus>
    }

    <div slot="details">
      <!-- TODO: Temporary fix for old surveys -->
      @if (surveyModel().settings) {
        @if (surveyModel().settings?.useTitleInd) {
          <h1 class="title survey-viewer__html-content fs__xxl fw__600" [innerHTML]="surveyModel().title"></h1>
        }
      } @else {
        <h1 class="title survey-viewer__html-content fs__xxl fw__600" [innerHTML]="surveyModel().title"></h1>
      }
      <div class="survey-viewer__html-content fs__xl fw__400" [innerHTML]="surveyModel().welcomeHtml"></div>
    </div>

    <empathy-viewer-button
      slot="actions"
      class="survey-viewer__start-btn"
      [text]="'Start Survey'"
      [color]="'primary'"
      [icon]="faArrowRight"
      [iconPosition]="'right'"
      (clicked)="start.emit()"
    ></empathy-viewer-button>
  </empathy-viewer-template-card>
</div>
